// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1PwNL","overflowing":"ReadFullNote_overflowing__2HZKY"};